import { StaticEntityKey } from 'models';
import { EntitySelectors } from '../../entity-feature-store';

export const selectOffer = EntitySelectors.getEntitySelectorByKey(StaticEntityKey.Offer);
